import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import withSizes from 'react-sizes';
import WorldMap from '../../../components/WorldMap';
import './style.scss';

const Interactive = withRouter(({ isMobile, history, shortname }) => {
    const [content, setContent] = useState({});

    useEffect(() => {
        const data = require('./data/' + shortname + '.js');
        setContent(data.content);
    }, [shortname]);

    return (
        <>
            <ul className={'interactive bg-black ' + shortname}>
                <li>{content.body && <div>{content.body()}</div>}</li>
                <li className="no-padding">
                    {shortname === 'modern-slavery' && (
                        <WorldMap
                            hideLabels={true}
                            hideMenu={true}
                            setDesktopView="-50 -50 1100 900"
                            onSelect={() => {
                                if (!isMobile) {
                                    history.push('/world-transparency');
                                }
                            }}
                        />
                    )}
                    {shortname === 'world-transparency' && (
                        <div className="view">
                            <WorldMap />
                        </div>
                    )}
                </li>
            </ul>
            <Footers title={content.lowerTitle} items={content.lowerItems} />
        </>
    );
});

const Footers = ({ title, items }) =>
    !title || !items ? (
        <></>
    ) : (
        <ul className="split-about black">
            <li>{title}</li>
            {items.map((item, key) => (
                <li key={key}>
                    <a
                        href={item.url}
                        title={item.content}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <p>{item.content}</p>
                    </a>
                </li>
            ))}
            <div className="scroll black">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </ul>
    );

const mapSizesToProps = ({ width }) => ({
    isMobile: width <= 1024,
});

export default withSizes(mapSizesToProps)(Interactive);
